export default [
  {
    path: '/editor/draft',
    name: 'editorDraft',
    component: () => import('@/views/editor/draft.vue'),
    meta: { title: '漫剪剪', requireAuth: true }
  },
  {
    path: '/editor/avatar',
    name: 'editorAvatar',
    component: () => import('@/views/editor/avatar.vue'),
    meta: { title: '头像编辑器', requireAuth: true }
  }
]
